import { VolumeDetailList } from './VolumeDetailList';

export class VolumeDetailItem {
  volume: VolumeDetailList;
  media: any;
}
